import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import Http from '../../../../Http';

class AddCliente extends FormComponent {

  componentDidMount() {
    // console.log(this.props.match.params)
    this.FormConfig(
      { defaultUrl: 'cliente-grupo', saveUrl: 'cliente-grupo/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/Grupos' },
      new Form([
        Form.Field('autocomplete', 'cliente', 'Cliente', '', [Validators.required], 12),
      ], ['Agregar al Grupo'], 'Agregar'), this.formData
    )
  }

  onSubmit = async (i, vals) => {
    vals.id_cliente_main = (this.props.cliente) ? this.props.cliente : this.props.match.params.id;
    // vals.id = this.props.match.params.tabId;
    vals.id_cliente = vals.cliente
    var Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true, FormData: Form.Reset(this.state.FormData) }, () => {
        if (this.props.back)
          this.props.history.push(`${this.config.backUrl}`)
        this.props.onSave(Res.data);
      });
    }
    else
      this.setState({ loading: false, sbMsg: `Error al guardar: ${Res.errMsg}`, sbOpen: true });
  }

  formData = async (form) => {
    let newForm = form;
    if (this.cliente) {
      const Res = await Http.get(`cliente/form/grupos?cliente=${this.cliente}`);
      if (!Res.error) {
        const { clientes } = Res.data;
        if (clientes) {
          newForm = Form.FieldOptions(newForm, 'cliente', clientes, 'id', 'cliente');
        }
      }
    }

    newForm = Form.ValueChange(newForm, {
      cliente: this.clienteChange,
    });
    return newForm;
  }

  clienteChange = async (field) => {
    if (field.Value && !isNaN(field.Value)) {
    } else {
      this.cliente = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData)
      });
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}


export default withRouter(AddCliente);
